import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  resetSuccessMsg: null,
  resetError: null,
};

const resetPasswordSlice = createSlice({
  name: "resettpwd",
  initialState,
  reducers: {
    userResetPasswordSuccess(state, action) {
      state.forgetSuccessMsg = action.payload;
    },
    userResetPasswordError(state, action) {
      state.forgetError = action.payload;
    },
  },
});

export const { userResetPasswordSuccess, userResetPasswordError } =
  resetPasswordSlice.actions;

export default resetPasswordSlice.reducer;
